import React, { useState, useEffect } from "react";
import { FiEdit, FiPlus, FiTrash } from "react-icons/fi";
import { GoArrowLeft } from "react-icons/go";
import { MdOutlineEdit } from "react-icons/md";
import profileImage from "../../../assets/profileimage.png";
import { json, Link } from "react-router-dom";
import LocationSelector from "../Summary/JustMap.jsx";
import { useSelector } from "react-redux";
import api from "../../../utils/api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { showCustomAlert } from "../Signup/Toast";
import GoogleMapsTracking from "../Summary/maps.jsx";
import GoogleMapsTrackingTwo from "../Summary/Maps2.jsx";
const ProfileForm = () => {
  const user = useSelector((state) => state.user.user);
  console.log("🚀 ~ ProfileForm ~ user:", user)
const [loading , setLoading] = useState(false)
const maxChars = 150;

  // const getAddress = async ()=>{
  //   try {
  //     const response = api.get('')
  //   } catch (error) {
      
  //   }
  // }
  // Initial values from the user object
  const initialValues = {
    name: user?.name || "Mr. John",
    email: user?.email || "*****@gmail.com",
    mobile: user?.contact || "---",
    address: user?.addresses[0]?.address || "---",
    notes : user?.notes || ""
    // paymentMethod: user?.paymentMethod || "Paypal*",
    // postCode: user?.postCode || "123456879",
  };
  // const parsedAddresses = user?.address?.length
  // ? JSON.parse(user.address[0])
  // : [];
  // Form fields data
  const [name, setName] = useState(initialValues.name);
  const [email, setEmail] = useState(initialValues.email);
  const [mobile, setMobile] = useState(initialValues.mobile);
 const [notes, setNotes] = useState(initialValues?.notes)
  const [addresses, setAddresses] = useState(user?.addresses);
  const [newAddress, setNewAddress] = useState("");
console.log("addresses", addresses)
  // const [paymentMethod, setPaymentMethod] = useState(initialValues.paymentMethod);
  // const [postCode, setPostCode] = useState(initialValues.postCode);

  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [isEditingMobile, setIsEditingMobile] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [isEditingNotes, setIsEditingNotes] = useState(false)
  // const [isEditingPaymentMethod, setIsEditingPaymentMethod] = useState(false);
  // const [isEditingPostCode, setIsEditingPostCode] = useState(false);

  // Handle edit click
  const handleEditClick = (field) => {
    if (field === "name") setIsEditingName(!isEditingName);
    if (field === "email") setIsEditingEmail(!isEditingEmail);
    if (field === "mobile") setIsEditingMobile(!isEditingMobile);
    if (field === "address") setIsEditingAddress(!isEditingAddress);
    if (field === "notes") setIsEditingNotes(!isEditingNotes);
    // if (field === "paymentMethod") setIsEditingPaymentMethod(!isEditingPaymentMethod);
    // if (field === "postCode") setIsEditingPostCode(!isEditingPostCode);
  };

  // Handle input change
  const handleChange = (field, newValue) => {
    if (field === "name") setName(newValue);
    if (field === "email") setEmail(newValue);
    if (field === "mobile") setMobile(newValue);
    if(field === "notes") setNotes(newValue)
//  if (field === "address") setAddress([initialValues.address, newValue]);

    // if (field === "paymentMethod") setPaymentMethod(newValue);
    // if (field === "postCode") setPostCode(newValue);
  };
  const handleAddAddress = async(address) => {
    console.log("address", address)
    try {
      const payload = {
        isPrimary: false,
        address: address, 
        userId : user?._id
      }
      const response = await api.patch('/users/updateOrAddAddress',payload)
      window.location.reload()
    } catch (error) {
      console.log(error)
    }
  }
  const handleSetPrimary = async (address) => {
    try {
      const payload = {
        isPrimary: true,
        address: address?.address, 
        userId : user?._id,
        addressId: address?._id
      }
      const response = await api.patch('/users/updateOrAddAddress',payload)
      window.location.reload()
    } catch (error) {
      console.log(error)
    }
  };
  // Edit existing address
  const handleDelete = async(address) => {
    try {
      const payload = {
        isPrimary: false,
        address: " ", 
        userId : user?._id,
        addressId: address?._id
      }
      const response = await api.patch('/users/updateOrAddAddress',payload)
      window.location.reload()
    } catch (error) {
      console.log(error)
    }
  
  };

  // Delete an address

  const handleConfirm = async () => {
    try {
      if (mobile !== initialValues.mobile) {
        try {
          // Validate phone number before submitting the form
          const validateResponse = await api.post("/order/validatePhone", { phone: mobile });
  
          if (!validateResponse.data.success) {
            Swal.fire("Error!", validateResponse.data.message || "Invalid phone number.", "error");
            return; // Stop execution if phone validation fails
          }
        } catch (validationError) {
          console.error("Phone validation failed:", validationError);
           showCustomAlert({
                  title: 'Please Try Again!',
                  html: `<p style="color: #555;">${validationError?.response?.data?.message}</p>`,
                  icon: 'error',
                  confirmbuttonText: 'ok',
                  confirmbuttonColor: '#af313d',
                  background: '#ffffff',
                  timer: 125000,
                });
            
        
          return; // Stop execution if phone validation API fails
        }
      }
  
      const formData = new FormData();
      if (name !== initialValues.name) formData.append("name", name);
      if (email !== initialValues.email) formData.append("email", email);
      if (mobile !== initialValues.mobile) formData.append("contact", mobile);
      if (notes !== initialValues.notes) formData.append("notes", notes);
   
      // Make the PATCH request with FormData
      const response = await api.patch(`/users/${user._id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response.status === 200) {
        Swal.fire("Success!", "Profile updated successfully.", "success");
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      } else {
        Swal.fire("Error!", "Failed to update profile. Please try again.", "error");
      }
     
    } catch (error) {
      console.error("Error updating profile:", error);
      Swal.fire("Error!", "Failed to update profile. Please try again.", "error");
    } finally {
      setIsEditingName(false);
      setIsEditingEmail(false);
      setIsEditingMobile(false);
      setIsEditingAddress(false);
      setIsEditingNotes(false);
    }
  };
  
  
  const handleNotesChange = (e) => {

    const value = e.target.value;
    if (value.length <= maxChars) {
      handleChange("notes", e.target.value)
    }
  };


  return (
    <div className="lg:max-w-[80%] sm:max-w-[80%] max-w-[90%] md:max-w-[80%] mx-auto p-4 bg-white rounded-xl shadow-sm mb-5">
      <Link to="/dashboard">
        <GoArrowLeft className="text-[1.5rem] cursor-pointer" />
      </Link>
      {/* Profile Picture Section */}
      {/* <div className="flex items-center mt-6 max-w-[90%] mx-auto justify-between lg:h-[125px] md:h-[100px] h-[70px] sm:h-[70px] bg-[#F2EBEB] p-4 rounded-lg shadow-sm md:mb-8 mb-4">
        <div className="flex items-center">
          <img
            src={profileImage} // Replace with your image URL
            alt="Profile"
            className="lg:w-[92px] lg:h-[92px] w-[50px] h-[50px] sm:w-[50px] sm:h-[50px] md:w-[70px] md:h-[70px] rounded-full object-cover"
          />
        </div>
        <button className="text-black lg:w-[58px] lg:h-[58px] bg-white mr-6 rounded-full w-10 flex items-center justify-center h-10 hover:text-blue-500">
          <MdOutlineEdit className="md:text-[2rem] text-[1.5rem] sm:text-[1.5rem]" />
        </button>
      </div> */}

      {/* Fields Section */}
      
      <div
        className="flex items-center justify-between max-w-[90%] lg:h-[125px] h-[70px] sm:h-[70px] md:h-[100px] mx-auto bg-[#F2EBEB] p-4 rounded-lg shadow-sm md:mb-8 mb-4"
      >
        <div>
          <label className="block body lg:text-[40px] text-[22px] sm:text-[22px] md:text-[28px] body font-medium text-[#000000]">
            Name
          </label>
          {isEditingName ? (
            <input
              type="text"
              value={name}
              onChange={(e) => handleChange("name", e.target.value)}
              className="block body lg:text-[25px] text-[14px] body text-gray-800 bg-white border border-white rounded-md p-2 w-full"
            />
          ) : (
            <span className="block body lg:text-[25px] text-[14px] md:text-[18px] body text-gray-800">
              {name}
            </span>
          )}
        </div>
        <button
          onClick={() => handleEditClick("name")}
          className="text-black body bg-white lg:w-[58px] lg:h-[58px] mr-6 rounded-full w-10 flex items-center justify-center h-10 hover:text-blue-500"
        >
          <MdOutlineEdit className=" md:text-[2rem] sm:text-[1.5rem] text-[1.5rem]" />
        </button>
      </div>
      <div
        className="flex items-center justify-between max-w-[90%]  mx-auto bg-[#F2EBEB] p-4 rounded-lg shadow-sm md:mb-8 mb-4"
      >
        <div className=" flex justify-between items-center w-full">
          <label className="block body lg:text-[40px] text-[22px] sm:text-[22px] md:text-[28px] body font-medium text-[#000000]">
            ID
          </label>
          
            <span className="block body lg:text-[25px] text-[14px] md:text-[18px] body text-gray-800 md:ml-10">
              {user?._id?.slice(-6)}
            </span>
        
        </div>
        
      </div>
      <div
        className="flex items-center justify-between max-w-[90%] lg:h-[125px] h-[70px] sm:h-[70px] md:h-[100px] mx-auto bg-[#F2EBEB] p-4 rounded-lg shadow-sm md:mb-8 mb-4"
      >
        <div>
          <label className="block lg:text-[40px] text-[22px] body sm:text-[22px] md:text-[28px] body font-medium text-[#000000]">
            Email
          </label>
          {isEditingEmail ? (
            <input
              type="text"
              value={email}
              onChange={(e) => handleChange("email", e.target.value)}
              className="block lg:text-[25px] text-[14px] body body text-gray-800 bg-white border border-white rounded-md p-2 w-full"
            />
          ) : (
            <span className="block lg:text-[25px]  body text-[14px] md:text-[18px] body text-gray-800">
              {email}
            </span>
          )}
        </div>
        <button
          onClick={() => handleEditClick("email")}
          className="text-black bg-white lg:w-[58px] body lg:h-[58px] mr-6 rounded-full w-10 flex items-center justify-center h-10 hover:text-blue-500"
        >
          <MdOutlineEdit className=" md:text-[2rem] sm:text-[1.5rem] text-[1.5rem]" />
        </button>
      </div>

      <div
        className="flex items-center justify-between max-w-[90%] lg:h-[125px] h-[70px] sm:h-[70px] md:h-[100px] mx-auto bg-[#F2EBEB] p-4 rounded-lg shadow-sm md:mb-8 mb-4"
      >
        <div>
          <label className="block lg:text-[40px] body text-[22px] sm:text-[22px] md:text-[28px] body font-medium text-[#000000]">
            Mobile number
          </label>
          {isEditingMobile ? (
            <input
              type="text"
              value={mobile}
              onChange={(e) => handleChange("mobile", e.target.value)}
              className="block lg:text-[25px] text-[14px] body text-gray-800 bg-white border border-white rounded-md p-2 w-full"
            />
          ) : (
            <span className="block lg:text-[25px] body text-[14px] md:text-[18px] body text-gray-800">
              {mobile}
            </span>
          )}
        </div>
        <button
          onClick={() => handleEditClick("mobile")}
          className="text-black bg-white lg:w-[58px] lg:h-[58px] mr-6 rounded-full w-10 flex items-center justify-center h-10 hover:text-blue-500"
        >
          <MdOutlineEdit className=" md:text-[2rem] sm:text-[1.5rem] text-[1.5rem]" />
        </button>
      </div>

      <div className="flex flex-col w-full  max-w-[90%]  mx-auto bg-[#F2EBEB] p-4 rounded-lg shadow-sm md:mb-8 mb-4 font-baloo">
            <h2 className="block lg:text-[40px] body text-[22px] sm:text-[22px] md:text-[28px] body font-medium text-[#000000]">Manage Addresses</h2>
      
            {/* Existing Addresses */}
           
            <div className="space-y-4">
            {addresses
  .filter((addr) => addr?.address?.trim() !== '') // Filter out empty addresses
  .map((addr) => (
    <div
      key={addr?._id}
      className={`flex items-center justify-between p-3 mb-2 rounded-lg ${
        addr?.primary ? 'bg-green-100 border border-green-500' : 'bg-white'
      }`}
    >
      <p className="text-lg font-medium">{addr?.address}</p>
      {addr?.primary ? (
        <div className="flex justify-center items-center gap-1">
          <span className="text-green-600 font-semibold">Primary</span>
          {/* <button
            onClick={() => handleDelete(addr)}
            disabled={loading === addr?._id}
            className="p-2 rounded-sm text-rose-700"
          >
            <FiTrash />
          </button> */}
        </div>
      ) : (
        <div>
          <button
            onClick={() => handleSetPrimary(addr)}
            disabled={loading === addr?._id}
            className=" rounded-sm text-rose-700 -600"
          >
            Set as Primary
          </button>
          <button
            onClick={() => handleDelete(addr)}
            disabled={loading === addr?._id}
            className="p-2 rounded-sm text-rose-700"
          >
            <FiTrash />
          </button>
        </div>
      )}
    </div>
  ))}

    </div>
    <LocationSelector onAddressSelect={(address) => handleAddAddress(address)} />
    <div className=" flex justify-between items-center w-full mb-4">
            <h2 className="block lg:text-[40px] body text-[22px] sm:text-[22px] md:text-[28px] body font-medium text-[#000000]">additional information</h2>
            <button
          onClick={() => handleEditClick("notes")}
          className="text-black bg-white lg:w-[58px] body lg:h-[58px] mr-6 rounded-full w-10 flex items-center justify-center h-10 hover:text-blue-500"
        >
          <MdOutlineEdit className=" md:text-[2rem] sm:text-[1.5rem] text-[1.5rem]" />
        </button>
            </div>
            {/* Existing Addresses */}
          {isEditingNotes ? (
            <>
            <textarea 
            name="notes" 
            value={notes}
            onChange={handleNotesChange}
            className=" p-5 bg-white rounded border font-baloo"
            id="notes"/>
             <span className="text-gray-500 text-sm mt-2">
    {notes?.length}/{maxChars} characters
  </span>
            </>
          ): (
            <div className=" p-10 bg-white rounded border font-baloo">
           {notes}
           </div>
          )}
            
           
          </div>
      {/* <div className="flex flex-col w-full  max-w-[90%]  mx-auto bg-[#F2EBEB] p-4 rounded-lg shadow-sm md:mb-8 mb-4 font-baloo">
           
          </div> */}

     

{(isEditingMobile || isEditingEmail || isEditingName || isEditingAddress || isEditingNotes) && (
  <div className="bg-[#AC313C] flex items-center rounded-md lg:mt-10 justify-center text-center max-w-[90%] mx-auto md:h-[70px] h-[50px] lg:h-[100px] mt-5">
    <button
      onClick={handleConfirm}
      className="body font-medium lg:text-[40px] text-white"
    >
      Confirm
    </button>
  </div>
)}

    </div>
  );
};

export default ProfileForm;
